(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axvane-cart-extras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axvane-cart-extras')) {
    customElements.define('axvane-cart-extras', class AxvaneCartExtras extends HTMLElement {
      connectedCallback() {
        this.axvaneReadVersion = 0;
        this.axvaneExternalVersion = 0;
        this.axvaneStartHandler = () => this.axvaneStart();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.axvaneStartHandler, { once: true });
        else this.axvaneStart();
      }

      axvaneStart() {
        if (!this.isConnected || this.axvaneObserver) return;
        this.axvaneDrawer = document.querySelector('cart-drawer');
        if (!this.axvaneDrawer) return;
        this.axvaneProgress = this.querySelector('[data-axvane-progress-template]')?.content.firstElementChild.cloneNode(true);
        this.axvaneOptional = this.querySelector('[data-axvane-optional-template]')?.content.firstElementChild.cloneNode(true);
        this.axvaneGuard = this.querySelector('[data-axvane-guard-template]')?.content.firstElementChild.cloneNode(true);
        this.axvaneShippingRow = this.querySelector('[data-axvane-shipping-template]')?.content.firstElementChild.cloneNode(true);
        this.axvanePaymentRow = this.querySelector('[data-axvane-payments-template]')?.content.firstElementChild.cloneNode(true);
        this.axvaneGuardOn = this.dataset.axvaneGuardDefault === 'true';
        this.axvaneApps = this.querySelector('[data-axvane-cart-apps]');
        this.axvaneChangeHandler = axvaneEvent => {
          if (axvaneEvent.target.matches('[data-axvane-optional-input]')) this.axvaneChangeOptional(axvaneEvent.target);
          else if (axvaneEvent.target.matches('[data-axvane-guard-input]')) this.axvaneToggleGuard(axvaneEvent.target);
        };
        this.axvaneClickHandler = axvaneEvent => {
          if (axvaneEvent.target.closest('[data-axvane-upgrade-button]')) this.axvaneChangeOptional({ checked: true });
        };
        this.axvaneDrawer.addEventListener('change', this.axvaneChangeHandler);
        this.axvaneDrawer.addEventListener('click', this.axvaneClickHandler);
        this.axvaneDrawer.classList.add('axvane-cart-drawer');
        this.axvaneMount();
        this.axvaneObserver = new MutationObserver(() => {
          this.axvaneSyncCheckout();
          if (this.axvaneMount()) {
            this.axvaneRender();
            this.axvaneRefresh();
          }
        });
        this.axvaneObserver.observe(this.axvaneDrawer, { childList: true, subtree: true });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.axvaneUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, axvaneEvent => this.axvaneCartChanged(axvaneEvent));
        }
        this.axvaneRefresh();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.axvaneStartHandler);
        this.axvaneObserver?.disconnect();
        this.axvaneObserver = null;
        this.axvaneAbort?.abort();
        this.axvaneUnsubscribe?.();
        this.axvaneDrawer?.removeEventListener('change', this.axvaneChangeHandler);
        this.axvaneDrawer?.removeEventListener('click', this.axvaneClickHandler);
        this.axvaneDrawer?.classList.remove('axvane-cart-drawer');
        this.axvaneProgress?.remove();
        this.axvaneOptional?.remove();
        this.axvaneGuard?.remove();
        this.axvaneShippingRow?.remove();
        this.axvanePaymentRow?.remove();
        if (this.axvaneApps) {
          this.axvaneApps.hidden = true;
          this.append(this.axvaneApps);
        }
      }

      axvaneMount() {
        const axvaneHeader = this.axvaneDrawer.querySelector('.drawer__header');
        const axvaneCheckout = this.axvaneDrawer.querySelector('.cart__ctas');
        let axvaneChanged = false;
        if (axvaneHeader && this.axvaneProgress && !this.axvaneDrawer.contains(this.axvaneProgress)) {
          axvaneHeader.after(this.axvaneProgress);
          axvaneChanged = true;
        }
        for (const axvaneNode of [this.axvaneOptional, this.axvaneGuard, this.axvaneApps]) {
          if (axvaneCheckout && axvaneNode && !this.axvaneDrawer.contains(axvaneNode)) {
            axvaneCheckout.before(axvaneNode);
            axvaneChanged = true;
          }
        }
        if (this.axvaneShippingRow && !this.axvaneDrawer.contains(this.axvaneShippingRow)) {
          const axvaneTotals = this.axvaneDrawer.querySelector('.totals');
          if (axvaneTotals?.before) {
            axvaneTotals.before(this.axvaneShippingRow);
            axvaneChanged = true;
          }
        }
        if (this.axvanePaymentRow && axvaneCheckout?.after && !this.axvaneDrawer.contains(this.axvanePaymentRow)) {
          axvaneCheckout.after(this.axvanePaymentRow);
          axvaneChanged = true;
        }
        return axvaneChanged;
      }

      axvaneGetProgress(axvaneCart) {
        const axvaneQuantity = this.dataset.axvaneMode === 'quantity';
        const axvaneTarget = Number(axvaneQuantity ? this.dataset.axvaneTargetQuantity : this.dataset.axvaneTargetAmount);
        const axvaneMatchProduct = axvaneItem => String(axvaneItem.product_id) === this.dataset.axvaneProductId || (Boolean(this.dataset.axvaneProductId) && axvaneItem.handle === 'axvane-offset-extension-wrench');
        const axvaneCurrent = axvaneQuantity
          ? axvaneCart.items.filter(axvaneMatchProduct).reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.quantity, 0)
          : axvaneCart.total_price;
        return {
          visible: axvaneCart.item_count > 0 && axvaneTarget > 0 && (axvaneQuantity ? Boolean(this.dataset.axvaneProductId) : this.dataset.axvaneMode === 'amount' && this.dataset.axvaneAmountEnabled === 'true'),
          current: axvaneCurrent,
          target: axvaneTarget,
          remaining: Math.max(0, axvaneTarget - axvaneCurrent),
          percentage: Math.max(0, Math.min(100, axvaneCurrent / axvaneTarget * 100)),
          reached: axvaneCurrent >= axvaneTarget
        };
      }

      axvaneOptionalLines(axvaneCart) {
        return axvaneCart.items.filter(axvaneItem => String(axvaneItem.variant_id) === this.dataset.axvaneOptionalVariant && axvaneItem.properties?._axvane_optional === this.dataset.axvaneSectionId);
      }

      axvaneUpgradeOffer(axvaneCart) {
        if (this.dataset.axvaneUpgradeMode !== 'true' || axvaneCart.currency !== this.dataset.axvaneUpgradeCurrency || !this.dataset.axvaneOptionalVariant) return null;
        if (axvaneCart.cart_level_discount_applications?.length) return null;
        const axvaneMatchProduct = axvaneItem => String(axvaneItem.product_id) === this.dataset.axvaneProductId || (Boolean(this.dataset.axvaneProductId) && axvaneItem.handle === 'axvane-offset-extension-wrench');
        const axvaneMatchVariant = axvaneItem => String(axvaneItem.variant_id) === this.dataset.axvaneOptionalVariant || (Boolean(this.dataset.axvaneOptionalVariant) && axvaneItem.handle === 'axvane-offset-extension-wrench');
        const axvaneLines = axvaneCart.items.filter(axvaneMatchProduct);
        if (!axvaneLines.length || axvaneLines.some(axvaneItem =>
          !axvaneMatchVariant(axvaneItem) || axvaneItem.selling_plan_allocation ||
          !Number.isInteger(axvaneItem.quantity) || axvaneItem.quantity < 1 || !Number.isInteger(axvaneItem.final_line_price)
        )) return null;
        const axvaneQuantity = axvaneLines.reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.quantity, 0);
        if (axvaneQuantity < 1 || axvaneQuantity >= 3) return null;
        const axvanePrices = [0, Number(this.dataset.axvaneUpgradeSingle), Number(this.dataset.axvaneUpgradeDouble), Number(this.dataset.axvaneUpgradeTriple)];
        const axvaneCurrent = axvaneLines.reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.final_line_price, 0);
        const axvaneTarget = axvanePrices[axvaneQuantity + 1];
        if (axvaneCurrent !== axvanePrices[axvaneQuantity] || !Number.isInteger(axvaneTarget) || axvaneTarget <= axvaneCurrent) return null;
        const axvaneLine = axvaneLines.filter(axvaneItem => axvaneItem.key && !Object.keys(axvaneItem.properties || {}).length)
          .sort((axvaneA, axvaneB) => axvaneA.key.localeCompare(axvaneB.key))[0];
        if (!axvaneLine) return null;
        return { line: axvaneLine, quantity: axvaneQuantity, amount: axvaneTarget - axvaneCurrent, target: axvaneTarget };
      }

      axvaneBuildMutation(axvaneChecked, axvaneCart) {
        if (this.dataset.axvaneUpgradeMode === 'true') {
          const axvaneOffer = axvaneChecked && this.axvaneUpgradeOffer(axvaneCart);
          return axvaneOffer ? { path: 'cart/update.js', body: { updates: { [axvaneOffer.line.key]: axvaneOffer.line.quantity + 1 } } } : null;
        }
        if (!this.dataset.axvaneOptionalVariant || !axvaneCart.item_count) return null;
        const axvaneLines = this.axvaneOptionalLines(axvaneCart);
        if (axvaneChecked) {
          if (axvaneLines.length) return null;
          return { path: 'cart/add.js', body: { items: [{ id: Number(this.dataset.axvaneOptionalVariant), quantity: 1, properties: { _axvane_optional: this.dataset.axvaneSectionId } }] } };
        }
        if (!axvaneLines.length) return null;
        return { path: 'cart/update.js', body: { updates: Object.fromEntries(axvaneLines.map(axvaneItem => [axvaneItem.key, 0])) } };
      }

      axvaneMoney(axvaneAmount) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.axvaneCart?.currency || this.dataset.axvaneCurrency || 'USD' }).format(axvaneAmount / 100);
      }

      axvaneText(axvaneNode, axvaneValue) {
        if (axvaneNode && axvaneNode.textContent !== axvaneValue) axvaneNode.textContent = axvaneValue;
      }

      axvaneSyncCheckout() {
        if (this.axvaneBusy) {
          const axvaneCheckout = this.axvaneDrawer?.querySelector?.('#CartDrawer-Checkout');
          if (!axvaneCheckout) return;
          this.axvaneCheckoutStates ??= new Map();
          if (!this.axvaneCheckoutStates.has(axvaneCheckout)) this.axvaneCheckoutStates.set(axvaneCheckout, axvaneCheckout.disabled);
          axvaneCheckout.disabled = true;
        } else {
          this.axvaneCheckoutStates?.forEach((axvaneDisabled, axvaneCheckout) => {
            axvaneCheckout.disabled = axvaneDisabled || !this.axvaneCart?.item_count;
          });
          this.axvaneCheckoutStates?.clear();
        }
      }

      axvaneRender() {
        if (!this.axvaneCart) return;
        const axvaneState = this.axvaneGetProgress(this.axvaneCart);
        if (this.axvaneProgress) {
          this.axvaneProgress.hidden = !axvaneState.visible;
          this.axvaneProgress.setAttribute('data-axvane-reached', String(axvaneState.reached));
          const axvaneRemaining = this.dataset.axvaneMode === 'amount' ? this.axvaneMoney(axvaneState.remaining) : String(axvaneState.remaining);
          const axvaneMessage = (axvaneState.reached ? this.dataset.axvaneReached : this.dataset.axvaneRemaining)
            .replaceAll('{remaining}', axvaneRemaining).replaceAll('{target}', String(axvaneState.target)).replaceAll('{quantity}', String(axvaneState.current));
          this.axvaneText(this.axvaneProgress.querySelector('[data-axvane-progress-message]'), axvaneMessage);
          const axvaneBar = this.axvaneProgress.querySelector('[data-axvane-progress-bar]');
          axvaneBar.value = axvaneState.percentage;
          axvaneBar.hidden = axvaneState.reached;
          const axvaneTotal = this.axvaneProgress.querySelector('[data-axvane-cart-total]');
          if (axvaneTotal) {
            axvaneTotal.hidden = axvaneState.reached;
            this.axvaneText(axvaneTotal, this.dataset.axvaneTotal.replaceAll('{total}', this.axvaneMoney(this.axvaneCart.total_price)));
          }
        }
        if (this.axvaneOptional) {
          this.axvaneOptional.setAttribute('aria-busy', String(Boolean(this.axvaneBusy)));
          const axvaneUpgrade = this.axvaneOptional.querySelector('[data-axvane-upgrade-button]');
          const axvaneInput = this.axvaneOptional.querySelector('[data-axvane-optional-input]');
          if (axvaneUpgrade) {
            const axvaneOffer = this.axvaneUpgradeOffer(this.axvaneCart);
            this.axvaneOptional.hidden = !axvaneOffer && !this.axvaneError;
            axvaneUpgrade.hidden = !axvaneOffer;
            axvaneUpgrade.disabled = Boolean(this.axvaneBusy) || !axvaneOffer;
            if (axvaneOffer) this.axvaneText(axvaneUpgrade, (axvaneOffer.quantity === 1 ? this.dataset.axvaneUpgradeSecond : this.dataset.axvaneUpgradeThird).replaceAll('{amount}', this.axvaneMoney(axvaneOffer.amount)));
          } else if (axvaneInput) {
            this.axvaneOptional.hidden = this.axvaneCart.item_count === 0;
            axvaneInput.checked = this.axvaneBusy ? this.axvaneRequested : this.axvaneOptionalLines(this.axvaneCart).length > 0;
            axvaneInput.disabled = Boolean(this.axvaneBusy);
          }
          const axvaneError = this.axvaneOptional.querySelector('[data-axvane-optional-error]');
          this.axvaneText(axvaneError, this.axvaneError || '');
          axvaneError.hidden = !this.axvaneError;
        }
        if (this.axvaneApps) this.axvaneApps.hidden = this.axvaneCart.item_count === 0;
        if (this.axvaneCart.attributes?.shipping_guard === 'Declined' && !this.axvaneUserToggledGuard) this.axvaneGuardOn = false;
        else if ((this.axvaneCart.attributes?.shipping_guard === 'Included (+$4.97)' || this.axvaneCart.attributes?.shipping_guard === 'Included (+$3.99)') && !this.axvaneUserToggledGuard) this.axvaneGuardOn = true;
        const axvaneGuardEnabled = this.dataset.axvaneGuardEnabled === 'true';
        const axvaneGuardVariant = Number(this.dataset.axvaneGuardVariant);
        const axvaneHasGuardVariant = Number.isInteger(axvaneGuardVariant) && axvaneGuardVariant > 0;
        const axvaneGuardInCart = axvaneHasGuardVariant
          && this.axvaneCart.items.some(axvaneItem => Number(axvaneItem.variant_id) === axvaneGuardVariant && axvaneItem.quantity > 0);
        const axvaneNonGuardCount = axvaneHasGuardVariant
          ? this.axvaneCart.items.filter(axvaneItem => Number(axvaneItem.variant_id) !== axvaneGuardVariant).reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.quantity, 0)
          : this.axvaneCart.item_count;
        const axvaneGuardPrice = Number(this.dataset.axvaneGuardPrice) || 497;
        const axvaneGuardFee = (!axvaneGuardEnabled || axvaneNonGuardCount === 0)
          ? (axvaneGuardInCart ? -axvaneGuardPrice : 0)
          : (this.axvaneGuardOn ? (axvaneGuardInCart ? 0 : axvaneGuardPrice) : (axvaneGuardInCart ? -axvaneGuardPrice : 0));
        const axvaneLiveTotal = Math.max(0, this.axvaneCart.total_price + axvaneGuardFee);
        if (this.axvaneGuard) {
          this.axvaneGuard.hidden = axvaneNonGuardCount === 0 || !axvaneGuardEnabled;
          this.axvaneGuard.classList?.toggle('is-active', Boolean(this.axvaneGuardOn));
          const axvaneGuardInput = this.axvaneGuard.querySelector('[data-axvane-guard-input]');
          if (axvaneGuardInput) axvaneGuardInput.checked = Boolean(this.axvaneGuardOn);
        }
        if (this.axvaneShippingRow) {
          this.axvaneShippingRow.hidden = axvaneNonGuardCount === 0;
          const axvaneShipBadge = this.axvaneShippingRow.querySelector('[data-axvane-shipping-badge]');
          if (axvaneShipBadge) {
            if (axvaneGuardEnabled && this.axvaneGuardOn) {
              this.axvaneText(axvaneShipBadge, 'Shipping Guard (+$4.97) ✓');
              axvaneShipBadge.classList.add('is-free');
            } else if (axvaneState.reached) {
              this.axvaneText(axvaneShipBadge, 'FREE Standard Shipping ✓');
              axvaneShipBadge.classList.add('is-free');
            } else {
              this.axvaneText(axvaneShipBadge, 'Calculated at checkout (Free on 2+ kits)');
              axvaneShipBadge.classList.remove('is-free');
            }
          }
        }
        if (this.axvanePaymentRow) this.axvanePaymentRow.hidden = axvaneNonGuardCount === 0;
        const axvaneBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (axvaneBubble && axvaneHasGuardVariant) {
          axvaneBubble.hidden = axvaneNonGuardCount === 0;
          this.axvaneText(axvaneBubble.querySelector('[aria-hidden="true"]'), String(axvaneNonGuardCount));
        }
        if (this.axvaneGuard || this.axvaneShippingRow || this.axvanePaymentRow) {
          const axvaneNote = this.axvaneDrawer?.querySelector?.('#Details-CartDrawer, cart-note, .cart__note');
          if (axvaneNote) axvaneNote.hidden = true;
          const axvaneTaxNote = this.axvaneDrawer?.querySelector?.('.tax-note');
          if (axvaneTaxNote) {
            if (axvaneGuardEnabled && this.axvaneGuardOn) {
              this.axvaneText(axvaneTaxNote, 'Includes $4.97 Shipping Guard & Free Replacement Protection.');
            } else if (axvaneState.reached) {
              this.axvaneText(axvaneTaxNote, 'Free standard shipping unlocked. Taxes calculated at checkout.');
            } else {
              this.axvaneText(axvaneTaxNote, 'Add 1 more kit (+$30) for free standard shipping. Shipping & taxes calculated at checkout.');
            }
          }
          const axvaneTotalsVal = this.axvaneDrawer?.querySelector?.('.totals__total-value');
          if (axvaneTotalsVal) {
            this.axvaneText(axvaneTotalsVal, `${this.axvaneMoney(axvaneLiveTotal)} ${this.axvaneCart.currency || 'USD'}`);
          }
          const axvaneCheckoutBtn = this.axvaneDrawer?.querySelector?.('#CartDrawer-Checkout');
          if (axvaneCheckoutBtn) {
            this.axvaneText(axvaneCheckoutBtn, `🔒 Proceed to Secure Checkout • ${this.axvaneMoney(axvaneLiveTotal)}`);
          }
        }
      }

      async axvaneEnsureGuard() {
        const axvaneGuardEnabled = this.dataset.axvaneGuardEnabled === 'true';
        const axvaneGuardVariant = Number(this.dataset.axvaneGuardVariant);
        if (!axvaneGuardEnabled || !Number.isInteger(axvaneGuardVariant) || axvaneGuardVariant <= 0 || !this.axvaneCart || this.axvaneBusy || this.axvaneGuardSyncing) return;
        const axvaneNonGuardCount = this.axvaneCart.items.filter(axvaneItem => Number(axvaneItem.variant_id) !== axvaneGuardVariant).reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.quantity, 0);
        const axvaneGuardQty = this.axvaneCart.items.filter(axvaneItem => Number(axvaneItem.variant_id) === axvaneGuardVariant).reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.quantity, 0);
        const axvaneDesiredQty = (axvaneNonGuardCount > 0 && this.axvaneGuardOn) ? 1 : 0;
        const axvaneStaleChoice = axvaneNonGuardCount === 0 && Boolean(this.axvaneCart.attributes?.shipping_guard);
        if (axvaneGuardQty === axvaneDesiredQty && !axvaneStaleChoice) return;
        this.axvaneGuardSyncing = true;
        try {
          const axvaneBody = { updates: { [axvaneGuardVariant]: axvaneDesiredQty } };
          // An emptied cart forgets the guard choice so the next item starts from the store default.
          if (axvaneNonGuardCount > 0) {
            axvaneBody.attributes = {
              shipping_guard: axvaneDesiredQty ? 'Included (+$4.97)' : 'Declined',
              shipping_guard_fee: axvaneDesiredQty ? '$4.97' : '$0.00'
            };
          } else {
            axvaneBody.attributes = { shipping_guard: '', shipping_guard_fee: '' };
            if (!this.axvaneUserToggledGuard) this.axvaneGuardOn = this.dataset.axvaneGuardDefault === 'true';
          }
          await this.axvaneWriteGuard(axvaneBody);
        } catch {} finally {
          this.axvaneGuardSyncing = false;
        }
      }

      async axvaneToggleGuard(axvaneInput) {
        this.axvaneUserToggledGuard = true;
        this.axvaneGuardOn = Boolean(axvaneInput.checked);
        this.axvaneRender();
        try {
          const axvaneBody = {
            attributes: {
              shipping_guard: this.axvaneGuardOn ? 'Included (+$4.97)' : 'Declined',
              shipping_guard_fee: this.axvaneGuardOn ? '$4.97' : '$0.00'
            }
          };
          const axvaneGuardVariant = Number(this.dataset.axvaneGuardVariant);
          if (Number.isInteger(axvaneGuardVariant) && axvaneGuardVariant > 0) {
            const axvaneNonGuardCount = this.axvaneCart ? this.axvaneCart.items.filter(axvaneItem => Number(axvaneItem.variant_id) !== axvaneGuardVariant).reduce((axvaneSum, axvaneItem) => axvaneSum + axvaneItem.quantity, 0) : 1;
            axvaneBody.updates = { [axvaneGuardVariant]: (this.axvaneGuardOn && axvaneNonGuardCount > 0) ? 1 : 0 };
          }
          await this.axvaneWriteGuard(axvaneBody);
        } catch {}
      }

      // Shopify prepends added lines and the native drawer removes lines by position, so every guard write must repaint the drawer markup.
      async axvaneWriteGuard(axvaneBody) {
        const axvaneSections = this.axvaneDrawer?.getSectionsToRender?.().map(axvaneSection => axvaneSection.id).filter(Boolean) || [];
        if (axvaneSections.length) {
          axvaneBody.sections = axvaneSections;
          axvaneBody.sections_url = window.location.pathname;
        }
        const axvaneItems = this.axvaneDrawer?.querySelector?.('cart-drawer-items');
        axvaneItems?.setAttribute?.('aria-busy', 'true');
        try {
          const axvaneResponse = await fetch(this.axvaneURL('cart/update.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(axvaneBody)
          });
          if (!axvaneResponse?.ok) return;
          const axvaneUpdated = await axvaneResponse.json();
          if (!Array.isArray(axvaneUpdated?.items) || !Number.isFinite(axvaneUpdated.total_price)) return;
          this.axvaneCart = axvaneUpdated;
          if (document.getElementById?.('main-cart-items')) {
            window.location.reload();
            return;
          }
          this.axvanePaintSections(axvaneUpdated.sections);
          this.axvaneRender();
        } finally {
          axvaneItems?.removeAttribute?.('aria-busy');
        }
      }

      axvanePaintSections(axvaneSections) {
        if (!axvaneSections || typeof DOMParser !== 'function' || !this.axvaneDrawer?.getSectionsToRender) return;
        for (const axvaneSection of this.axvaneDrawer.getSectionsToRender()) {
          const axvaneHTML = axvaneSections[axvaneSection.id];
          if (typeof axvaneHTML !== 'string') continue;
          const axvaneTarget = axvaneSection.selector ? document.querySelector(axvaneSection.selector) : document.getElementById(axvaneSection.id);
          const axvaneSource = new DOMParser().parseFromString(axvaneHTML, 'text/html').querySelector(axvaneSection.selector || '.shopify-section');
          if (axvaneTarget && axvaneSource) axvaneTarget.innerHTML = axvaneSource.innerHTML;
        }
        this.axvaneDrawer.querySelector?.('#CartDrawer-Overlay')?.addEventListener('click', () => this.axvaneDrawer.close?.());
        this.axvaneDrawer.classList?.toggle('is-empty', !this.axvaneCart?.item_count);
        this.axvaneSyncCheckout();
        this.axvaneMount();
      }

      axvaneURL(axvanePath) {
        return `${window.Shopify?.routes?.root || '/'}${axvanePath}`;
      }

      async axvaneJSON(axvaneURL, axvaneOptions = {}) {
        const axvaneResponse = await fetch(axvaneURL, { credentials: 'same-origin', cache: 'no-store', ...axvaneOptions });
        const axvaneData = await axvaneResponse.json();
        if (!axvaneResponse.ok || axvaneData.status || axvaneData.errors) {
          throw new Error(typeof axvaneData.description === 'string' ? axvaneData.description : this.dataset.axvaneError);
        }
        return axvaneData;
      }

      async axvaneRefresh() {
        if (this.axvaneBusy) {
          this.axvaneNeedsRefresh = true;
          return;
        }
        const axvaneVersion = ++this.axvaneReadVersion;
        this.axvaneAbort?.abort();
        this.axvaneAbort = new AbortController();
        try {
          const axvaneCart = await this.axvaneJSON(this.axvaneURL('cart.js'), { signal: this.axvaneAbort.signal });
          if (axvaneVersion !== this.axvaneReadVersion || !this.isConnected) return;
          this.axvaneCart = axvaneCart;
          this.axvaneRender();
          await this.axvaneEnsureGuard();
        } catch (axvaneError) {
          if (axvaneError.name === 'AbortError') return;
        }
      }

      axvaneCartChanged(axvaneEvent) {
        if (axvaneEvent.source === `axvane-cart-extras:${this.dataset.axvaneSectionId}`) return;
        this.axvaneExternalVersion += 1;
        this.axvaneReadVersion += 1;
        this.axvaneAbort?.abort();
        if (this.axvaneBusy) {
          this.axvaneNeedsRefresh = true;
          return;
        }
        if (Array.isArray(axvaneEvent.cartData?.items) && Number.isFinite(axvaneEvent.cartData.total_price)) {
          this.axvaneCart = axvaneEvent.cartData;
          this.axvaneRender();
          this.axvaneEnsureGuard();
        } else this.axvaneRefresh();
      }

      async axvaneRenderNative(axvaneData) {
        if (!this.isConnected) return;
        const axvaneSections = this.axvaneDrawer.getSectionsToRender().map(axvaneSection => axvaneSection.id);
        if (!axvaneSections.every(axvaneId => typeof axvaneData.sections?.[axvaneId] === 'string')) {
          const axvaneURL = new URL(window.location.href);
          axvaneURL.searchParams.set('sections', axvaneSections.join(','));
          axvaneData.sections = await this.axvaneJSON(axvaneURL.toString());
        }
        if (!axvaneSections.every(axvaneId => typeof axvaneData.sections?.[axvaneId] === 'string')) throw new Error(this.dataset.axvaneError);
        const axvaneFocused = document.activeElement;
        const axvaneRestoreFocus = this.axvaneDrawer.contains(axvaneFocused);
        this.axvaneDrawer.classList.toggle('is-empty', this.axvaneCart.item_count === 0);
        this.axvaneDrawer.renderContents(axvaneData);
        this.axvaneSyncCheckout();
        this.axvaneMount();
        this.axvaneRender();
        if (axvaneRestoreFocus) {
          requestAnimationFrame(() => {
            if (!this.axvaneDrawer.classList.contains('active')) return;
            const axvaneContainer = this.axvaneDrawer.querySelector(this.axvaneCart.item_count ? '.drawer__inner' : '.drawer__inner-empty');
            const axvanePrevious = axvaneFocused?.isConnected ? axvaneFocused : document.getElementById(axvaneFocused?.id);
            const axvaneTarget = axvanePrevious && !axvanePrevious.closest('[hidden]')
              ? axvanePrevious : this.axvaneDrawer.querySelector('#CartDrawer-Checkout') || axvaneContainer;
            if (axvaneContainer && typeof trapFocus === 'function') trapFocus(axvaneContainer, axvaneTarget);
          });
        }
      }

      async axvaneChangeOptional(axvaneInput) {
        if (this.axvaneBusy) return;
        const axvaneChecked = axvaneInput.checked;
        this.axvaneRequested = axvaneChecked;
        this.axvaneBusy = true;
        this.axvaneError = '';
        this.axvaneReadVersion += 1;
        this.axvaneAbort?.abort();
        this.axvaneSyncCheckout();
        this.axvaneRender();
        try {
          const axvanePreflightVersion = this.axvaneExternalVersion;
          const axvaneCurrentCart = await this.axvaneJSON(this.axvaneURL('cart.js'));
          if (axvanePreflightVersion !== this.axvaneExternalVersion) {
            this.axvaneNeedsRefresh = true;
            return;
          }
          this.axvaneCart = axvaneCurrentCart;
          const axvaneMutation = this.axvaneBuildMutation(axvaneChecked, this.axvaneCart);
          if (!axvaneMutation) return;
          const axvaneExternalVersion = this.axvaneExternalVersion;
          axvaneMutation.body.sections = this.axvaneDrawer.getSectionsToRender().map(axvaneSection => axvaneSection.id);
          axvaneMutation.body.sections_url = window.location.pathname;
          const axvaneResponse = await this.axvaneJSON(this.axvaneURL(axvaneMutation.path), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(axvaneMutation.body)
          });
          this.axvaneCart = await this.axvaneJSON(this.axvaneURL('cart.js'));
          if (axvaneExternalVersion !== this.axvaneExternalVersion) axvaneResponse.sections = null;
          await this.axvaneRenderNative(axvaneResponse);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, { source: `axvane-cart-extras:${this.dataset.axvaneSectionId}`, cartData: this.axvaneCart });
          }
        } catch (axvaneError) {
          this.axvaneError = axvaneError.message || this.dataset.axvaneError;
          try { this.axvaneCart = await this.axvaneJSON(this.axvaneURL('cart.js')); } catch {}
        } finally {
          this.axvaneBusy = false;
          this.axvaneSyncCheckout();
          axvaneInput.checked = Boolean(this.axvaneCart && this.axvaneOptionalLines(this.axvaneCart).length);
          this.axvaneRender();
          if (this.axvaneNeedsRefresh) {
            this.axvaneNeedsRefresh = false;
            this.axvaneRefresh();
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axvane-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('axvane-details')) {
  customElements.define('axvane-details', class extends HTMLElement {
    connectedCallback() {
      if (this.axvaneEvents) return;
      this.axvaneEvents = new AbortController();
      this.axvaneMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.axvaneVisibleVideos = new Set();
      const axvaneOptions = { signal: this.axvaneEvents.signal };
      this.addEventListener('input', axvaneEvent => {
        const axvaneRange = axvaneEvent.target.closest('[data-axvane-range]');
        if (!axvaneRange) return;
        const axvaneNumber = Number(axvaneRange.value);
        const axvaneSplit = Number.isFinite(axvaneNumber) ? Math.min(100, Math.max(0, axvaneNumber)) : 50;
        axvaneRange.closest('[data-axvane-comparison]').style.setProperty('--axvane-split', `${axvaneSplit}%`);
        axvaneRange.setAttribute('aria-valuenow', axvaneSplit);
      }, axvaneOptions);
      this.addEventListener('submit', axvaneEvent => {
        const axvaneForm = axvaneEvent.target.closest?.('[data-axvane-review-form]');
        if (!axvaneForm) return;
        axvaneEvent.preventDefault?.();
        const axvaneStatus = axvaneForm.querySelector?.('[data-axvane-review-status]');
        if (axvaneStatus) axvaneStatus.hidden = false;
        axvaneForm.reset?.();
      }, axvaneOptions);
      this.addEventListener('click', axvaneEvent => {
        if (axvaneEvent.target.closest('[data-axvane-replay]')) {
          if (this.axvaneMotion.matches) return;
          const axvaneHandle = this.querySelector('[data-axvane-handle]');
          if (!axvaneHandle?.animate) return;
          axvaneHandle.getAnimations().forEach(axvaneAnimation => axvaneAnimation.cancel());
          axvaneHandle.animate([{ transform: 'rotate(-18deg)' }, { transform: 'rotate(18deg)' }, { transform: 'rotate(-18deg)' }], { duration: 3000, iterations: 1, easing: 'ease-in-out' });
        }
        const axvaneMechTab = axvaneEvent.target.closest('[data-axvane-mech-clip]');
        if (axvaneMechTab) {
          const axvaneStageImg = this.querySelector('[data-axvane-mech-stage-img]');
          const axvaneStageCap = this.querySelector('[data-axvane-mech-caption]');
          if (axvaneStageImg && axvaneMechTab.dataset.axvaneMechClip) {
            axvaneStageImg.src = axvaneMechTab.dataset.axvaneMechClip;
          }
          if (axvaneStageCap && axvaneMechTab.dataset.axvaneMechLabel) {
            axvaneStageCap.textContent = axvaneMechTab.dataset.axvaneMechLabel;
          }
          this.querySelectorAll('[data-axvane-mech-clip]').forEach(btn => {
            const active = btn === axvaneMechTab;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-selected', String(active));
          });
          return;
        }
        const axvaneHelpful = axvaneEvent.target.closest('[data-axvane-helpful]');
        if (axvaneHelpful) {
          const axvaneLiked = axvaneHelpful.getAttribute('aria-pressed') === 'true';
          const axvaneBase = Number(axvaneHelpful.dataset.axvaneHelpful) || 18;
          const axvaneNext = axvaneLiked ? axvaneBase : axvaneBase + 1;
          axvaneHelpful.setAttribute('aria-pressed', String(!axvaneLiked));
          const axvaneCounter = axvaneHelpful.querySelector?.('[data-axvane-helpful-count]');
          if (axvaneCounter) axvaneCounter.textContent = String(axvaneNext);
          return;
        }
        const axvaneLoadMore = axvaneEvent.target.closest('[data-axvane-load-more]');
        if (axvaneLoadMore) {
          const axvaneExtraCards = [...this.querySelectorAll('[data-axvane-extra-review]')];
          axvaneExtraCards.forEach(axvaneCard => { axvaneCard.hidden = false; });
          const axvaneAllCards = [...this.querySelectorAll('.axvane-review-card')].filter(axvaneCard => !axvaneCard.hidden);
          const axvaneShownCount = axvaneAllCards.length || (6 + axvaneExtraCards.length) || 9;
          const totalRev = axvaneLoadMore.dataset.axvaneTotalReviews || '428';
          axvaneLoadMore.textContent = `Showing ${axvaneShownCount} of ${totalRev} Verified Reviews ✓`;
          axvaneLoadMore.disabled = true;
          return;
        }
        const axvaneWriteBtn = axvaneEvent.target.closest('[data-axvane-write-review]');
        if (axvaneWriteBtn) {
          const axvaneForm = this.querySelector('[data-axvane-review-form]');
          if (axvaneForm) {
            axvaneForm.hidden = !axvaneForm.hidden;
            axvaneWriteBtn.setAttribute('aria-expanded', String(!axvaneForm.hidden));
          }
          return;
        }
        if (axvaneEvent.target.closest('[data-axvane-close-review]')) {
          const axvaneForm = this.querySelector('[data-axvane-review-form]');
          const axvaneWriteBtn = this.querySelector('[data-axvane-write-review]');
          if (axvaneForm) axvaneForm.hidden = true;
          if (axvaneWriteBtn) axvaneWriteBtn.setAttribute('aria-expanded', 'false');
          return;
        }
        const axvaneZoom = axvaneEvent.target.closest('[data-axvane-zoom-media]');
        if (axvaneZoom) {
          const axvaneLightbox = this.querySelector('[data-axvane-lightbox]');
          const axvaneStage = this.querySelector('[data-axvane-lightbox-stage]');
          if (axvaneLightbox && axvaneStage) {
            axvaneStage.innerHTML = '';
            const axvaneVid = axvaneZoom.querySelector?.('video');
            const axvaneImg = axvaneZoom.querySelector?.('img');
            if (axvaneVid) {
              const clone = axvaneVid.cloneNode(true);
              clone.controls = true;
              clone.muted = false;
              axvaneStage.appendChild(clone);
              clone.play?.()?.catch(() => {});
            } else if (axvaneImg) {
              const clone = axvaneImg.cloneNode(true);
              axvaneStage.appendChild(clone);
            }
            axvaneLightbox.hidden = false;
          }
          return;
        }
        if (axvaneEvent.target.closest('[data-axvane-close-lightbox]')) {
          const axvaneLightbox = this.querySelector('[data-axvane-lightbox]');
          const axvaneStage = this.querySelector('[data-axvane-lightbox-stage]');
          if (axvaneStage) axvaneStage.innerHTML = '';
          if (axvaneLightbox) axvaneLightbox.hidden = true;
          return;
        }
        const axvaneButton = axvaneEvent.target.closest('[data-axvane-scroll]');
        if (!axvaneButton) return;
        const axvaneTrack = this.querySelector('[data-axvane-track]');
        axvaneTrack?.scrollBy({ left: Number(axvaneButton.dataset.axvaneScroll) * axvaneTrack.clientWidth * 0.8, behavior: this.axvaneMotion.matches ? 'auto' : 'smooth' });
      }, axvaneOptions);
      this.axvaneSyncMedia = () => {
        this.querySelectorAll('[data-axvane-video] video').forEach(axvaneVideo => {
          if (!document.hidden && !this.axvaneMotion.matches && this.axvaneVisibleVideos.has(axvaneVideo)) {
            axvaneVideo.play()?.catch(() => {});
          } else {
            axvaneVideo.pause();
          }
        });
      };
      document.addEventListener('visibilitychange', this.axvaneSyncMedia, axvaneOptions);
      this.axvaneMotion.addEventListener('change', this.axvaneSyncMedia, axvaneOptions);
      if (typeof IntersectionObserver === 'function') {
        this.axvaneObserver = new IntersectionObserver(axvaneEntries => {
          axvaneEntries.forEach(axvaneEntry => {
            if (axvaneEntry.target.dataset.axvaneResult !== undefined) {
              if (axvaneEntry.isIntersecting) axvaneEntry.target.setAttribute('data-axvane-visible', 'true');
              return;
            }
            if (axvaneEntry.isIntersecting && axvaneEntry.intersectionRatio >= 0.5) {
              this.axvaneVisibleVideos.add(axvaneEntry.target);
            } else {
              this.axvaneVisibleVideos.delete(axvaneEntry.target);
            }
          });
          this.axvaneSyncMedia();
        }, { threshold: [0, 0.5] });
        this.querySelectorAll('[data-axvane-video] video').forEach(axvaneVideo => this.axvaneObserver.observe(axvaneVideo));
        this.querySelectorAll('[data-axvane-result]').forEach(axvaneResult => this.axvaneObserver.observe(axvaneResult));
      }
    }
    disconnectedCallback() {
      this.axvaneEvents?.abort();
      this.axvaneEvents = null;
      this.axvaneObserver?.disconnect();
      this.axvaneVisibleVideos?.clear();
      this.querySelectorAll('[data-axvane-video] video').forEach(axvaneVideo => axvaneVideo.pause());
      this.querySelector('[data-axvane-handle]')?.getAnimations().forEach(axvaneAnimation => axvaneAnimation.cancel());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axvane-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('axvane-purchase')) {
  customElements.define('axvane-purchase', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('change', event => {
        if (event.target.name === 'quantity') this.syncOffer();
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-axvane-sticky-submit]')) this.submitFromSticky();
        const thumb = event.target.closest('[data-axvane-image]');
        if (!thumb) return;
        const image = this.querySelector('.axvane-purchase-main-image');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = thumb.dataset.axvaneImage;
        image.alt = thumb.dataset.axvaneAlt;
        this.querySelectorAll('[data-axvane-image]').forEach(node => node.setAttribute('aria-current', String(node === thumb)));
        const caption = this.querySelector('.axvane-purchase-caption');
        if (caption) caption.hidden = thumb !== this.querySelector('[data-axvane-image]');
      }, { signal: this.abort.signal });
      this.syncOffer();
      const delivery = this.querySelector('[data-axvane-delivery]');
      if (delivery) {
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
        const min = Math.max(0, Number(delivery.dataset.min));
        const max = Math.max(min, Number(delivery.dataset.max));
        const now = new Date();
        delivery.querySelector('[data-axvane-date]').textContent = formatter.format(this.deliveryDate(min, now)) + ' – ' + formatter.format(this.deliveryDate(max, now));
      }
      const stockDate = this.querySelector('[data-axvane-stock-date]');
      if (stockDate) {
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'short', month: 'short', day: 'numeric' });
        const days = Math.max(1, Number(stockDate.dataset.days) || 5);
        stockDate.textContent = formatter.format(this.deliveryDate(days, new Date()));
      }
      const main = this.querySelector('[data-axvane-submit]');
      const sticky = this.querySelector('.axvane-sticky');
      if (!main || !sticky) return;
      this.observer = new IntersectionObserver(entries => {
        this.passedPurchase = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        this.syncSticky();
      });
      this.observer.observe(main);
      this.scrollHandler = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.syncSticky(); });
      };
      window.addEventListener('scroll', this.scrollHandler, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', this.scrollHandler, { signal: this.abort.signal });
      this.syncSticky();
      this.stateObserver = new MutationObserver(() => {
        this.syncSticky();
        const error = this.querySelector('.product-form__error-message-wrapper');
        if (this.stickyRequested && error && !error.hidden && error.textContent.trim()) {
          error.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          this.stickyRequested = false;
        }
      });
      this.stateObserver.observe(this.querySelector('product-form'), { subtree: true, attributes: true, childList: true, attributeFilter: ['disabled','aria-disabled','class','hidden'] });
      const drawer = document.querySelector('cart-drawer');
      if (drawer) this.stateObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    syncOffer() {
      const selected = this.querySelector('input[name="quantity"]:checked');
      if (!selected) return;
      const price = Number(selected.dataset.price);
      if (!Number.isFinite(price)) return;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      const money = amount => formatter.format(amount / 100);
      const total = money(price);
      const quantity = Math.max(1, Number(selected.value) || 1);
      const unitCents = Math.round(price / quantity);
      const refAttr = Number(selected.dataset.referencePrice);
      const reference = Number.isFinite(refAttr) && refAttr > 0 ? refAttr : Number(this.dataset.unitPrice) * quantity;
      const saving = Math.max(0, reference - price);
      this.querySelectorAll('[data-axvane-total]').forEach(node => { node.textContent = total; });
      this.querySelectorAll('[data-axvane-offer-label]').forEach(node => { node.textContent = selected.dataset.label || ''; });
      this.querySelectorAll('[data-axvane-bundle-prefix]').forEach(node => { node.textContent = quantity > 1 ? `${quantity}-Kit Bundle Total:` : 'Single Kit Total:'; });
      this.querySelectorAll('[data-axvane-unit-price]').forEach(node => { node.textContent = (this.dataset.perKitTemplate || '{price} / kit').replace('{price}', money(unitCents)); });
      this.querySelectorAll('[data-axvane-sticky-deal]').forEach(node => {
        node.textContent = saving > 0 ? `Save ${money(saving)} · Free Ship` : `${money(unitCents)}/kit`;
      });
      this.querySelectorAll('[data-axvane-cta]').forEach(node => {
        node.textContent = (this.dataset.ctaTemplate || 'Add {quantity} {unit} · {total}').replace('{quantity}', quantity).replace('{unit}', quantity === 1 ? this.dataset.singleLabel || 'kit' : this.dataset.pluralLabel || 'kits').replace('{total}', total);
      });
      this.querySelectorAll('[data-axvane-reference]').forEach(node => { node.hidden = !Number.isFinite(saving) || saving <= 0; node.textContent = Number.isFinite(reference) ? money(reference) : ''; });
      const customSaving = selected.dataset.savingBadge;
      this.querySelectorAll('[data-axvane-saving]').forEach(node => {
        node.hidden = !Number.isFinite(saving) || saving <= 0;
        node.textContent = Number.isFinite(saving) && saving > 0 ? (customSaving || (this.dataset.savingsTemplate || 'Save {saving}').replace('{saving}', money(saving))) : '';
      });
    }
    syncSticky() {
      const main = this.querySelector('[data-axvane-submit]');
      const sticky = this.querySelector('.axvane-sticky');
      const button = this.querySelector('[data-axvane-sticky-submit]');
      if (!main || !sticky || !button) return;
      const busy = main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading');
      if (button.disabled !== busy) button.disabled = busy;
      const drawerOpen = Boolean(document.querySelector('cart-drawer.active'));
      if (drawerOpen) this.stickyRequested = false;
      const mainRect = main.getBoundingClientRect();
      this.passedPurchase = mainRect.bottom <= 0;
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const footer = document.querySelector?.('footer, .footer, .shopify-section-group-footer-group');
      const footerVisible = Boolean(footer?.getBoundingClientRect && footer.getBoundingClientRect().top < viewport);
      const show = this.passedPurchase;
      const hidden = !show || drawerOpen || footerVisible;
      if (sticky.hidden !== hidden) sticky.hidden = hidden;
    }
    submitFromSticky() {
      const form = this.querySelector('product-form form');
      const button = this.querySelector('[data-axvane-submit]');
      if (!form || !button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading')) return;
      if (!form.reportValidity()) return;
      this.stickyRequested = true;
      form.requestSubmit(button);
      const error = this.querySelector('.product-form__error-message-wrapper');
      if (error && !error.hidden) error.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    }
    deliveryDate(days, now = new Date()) {
      const date = new Date(now);
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + Number(days));
      return date;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.stateObserver?.disconnect();
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axvane-track-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTrackSection = (root) => {
      if (!root || root.dataset.trackBound === 'true') return;
      root.dataset.trackBound = 'true';

      const tabs = [...root.querySelectorAll('[data-track-tab]')];
      const forms = [...root.querySelectorAll('[data-track-form]')];
      const resultBox = root.querySelector('[data-track-result]');
      const badgeEl = root.querySelector('[data-track-result-badge]');
      const titleEl = root.querySelector('[data-track-result-title]');
      const metaEl = root.querySelector('[data-track-result-meta]');
      const extLink = root.querySelector('[data-track-external-link]');
      const step2 = root.querySelector('[data-track-step-2]');
      const step3 = root.querySelector('[data-track-step-3]');
      const noteEl = root.querySelector('[data-track-result-note]');
      const stepsEl = root.querySelector('[data-track-steps]');

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.trackTab;
          tabs.forEach((t) => {
            const active = t.dataset.trackTab === target;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });
          forms.forEach((f) => {
            f.hidden = f.dataset.trackForm !== target;
          });
        });
      });

      const orderForm = root.querySelector('[data-track-form="order"]');
      const carrierForm = root.querySelector('[data-track-form="carrier"]');

      orderForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        const orderInput = root.querySelector('[data-track-order-input]');
        const emailInput = root.querySelector('[data-track-email-input]');
        const errorEl = root.querySelector('[data-track-error]');
        const rawOrder = (orderInput?.value || '').trim();
        const rawEmail = (emailInput?.value || '').trim();

        if (!rawOrder || !rawEmail || !rawEmail.includes('@')) {
          if (errorEl) {
            errorEl.textContent = 'Please enter both your Order Number and the Email Address used at checkout.';
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;

        const cleanOrder = rawOrder.startsWith('#') ? rawOrder : `#${rawOrder}`;
        const safeOrder = cleanOrder.replace(/[<>&"']/g, '');
        const safeEmail = rawEmail.replace(/[<>&"']/g, '');
        // Shopify exposes real order status only after the buyer verifies the checkout email, so the lookup hands off to customer accounts.
        const accountUrl = resultBox?.dataset.trackAccountUrl || '/account';
        if (badgeEl) badgeEl.textContent = 'Secure Order Lookup';
        if (titleEl) titleEl.textContent = `Order ${safeOrder}`;
        if (metaEl) metaEl.textContent = `Sign in with ${safeEmail} to see the live status and tracking link for this order.`;
        if (extLink) {
          extLink.href = accountUrl;
          extLink.target = '_self';
          extLink.removeAttribute('rel');
          extLink.textContent = 'View Live Order Status →';
          extLink.hidden = false;
        }
        if (stepsEl) stepsEl.hidden = true;

        const mailSubject = encodeURIComponent(`Order Status Inquiry — ${cleanOrder}`);
        const mailBody = encodeURIComponent(`Hi AXVANE Support,\n\nI would like to check the latest shipping status for my order:\nOrder Number: ${cleanOrder}\nCheckout Email: ${rawEmail}\n\nThank you!`);
        if (noteEl) {
          noteEl.innerHTML = `<strong>How it works:</strong> Tap <strong>View Live Order Status</strong>, enter <strong>${safeEmail}</strong>, and type the 6-digit code we email you. You will see order <strong>${safeOrder}</strong> with its current fulfillment status and carrier tracking link—no password needed.<br><br>Prefer a person? <a href="mailto:support@axvane.store?subject=${mailSubject}&body=${mailBody}">Email support@axvane.store with Order ${safeOrder} pre-filled →</a>`;
        }
        if (resultBox) {
          resultBox.hidden = false;
          resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });

      carrierForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        const carrierInput = root.querySelector('[data-track-carrier-input]');
        const errorEl = root.querySelector('[data-track-carrier-error]');
        const rawTracking = (carrierInput?.value || '').trim().replace(/\s+/g, '');

        if (!rawTracking || rawTracking.length < 6) {
          if (errorEl) {
            errorEl.textContent = 'Please enter a valid carrier tracking number (at least 6 characters).';
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;

        const trackUrl = `https://t.17track.net/en#nums=${encodeURIComponent(rawTracking)}`;
        if (badgeEl) badgeEl.textContent = 'Carrier Tracking Ready';
        if (titleEl) titleEl.textContent = `Tracking #${rawTracking}`;
        if (metaEl) metaEl.textContent = 'Multi-carrier real-time scan lookup (USPS / UPS / FedEx / DHL)';
        if (extLink) {
          extLink.href = trackUrl;
          extLink.target = '_blank';
          extLink.rel = 'noopener noreferrer';
          extLink.textContent = 'Open Live Carrier Scan ↗';
          extLink.hidden = false;
        }
        if (stepsEl) stepsEl.hidden = false;
        step2?.classList.remove('is-current');
        step2?.classList.add('is-done');
        step3?.classList.add('is-current');

        if (noteEl) {
          noteEl.innerHTML = `<strong>Live Carrier Portal:</strong> Click <a href="${trackUrl}" target="_blank" rel="noopener noreferrer">Open Live Carrier Scan for #${rawTracking.replace(/[<>&"']/g, '')} ↗</a> to view the latest USPS, UPS, FedEx, or international hub scan timestamps. Remember: if your parcel ever stalls or arrives damaged, your order is backed by our <strong>Shipping Guard Free Replacement Guarantee</strong> at <a href="mailto:support@axvane.store">support@axvane.store</a>.`;
        }
        if (resultBox) {
          resultBox.hidden = false;
          resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    };

    document.querySelectorAll('.axvane-track').forEach(initTrackSection);
    document.addEventListener('shopify:section:load', (e) => {
      const sec = e.target?.querySelector?.('.axvane-track') || (e.target?.classList?.contains('axvane-track') ? e.target : null);
      if (sec) initTrackSection(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const initTrackSection = (root) => {
      if (!root || root.dataset.trackBound === 'true') return;
      root.dataset.trackBound = 'true';

      const tabs = [...root.querySelectorAll('[data-track-tab]')];
      const forms = [...root.querySelectorAll('[data-track-form]')];
      const resultBox = root.querySelector('[data-track-result]');
      const badgeEl = root.querySelector('[data-track-result-badge]');
      const titleEl = root.querySelector('[data-track-result-title]');
      const metaEl = root.querySelector('[data-track-result-meta]');
      const extLink = root.querySelector('[data-track-external-link]');
      const step2 = root.querySelector('[data-track-step-2]');
      const step3 = root.querySelector('[data-track-step-3]');
      const noteEl = root.querySelector('[data-track-result-note]');
      const stepsEl = root.querySelector('[data-track-steps]');

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.trackTab;
          tabs.forEach((t) => {
            const active = t.dataset.trackTab === target;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });
          forms.forEach((f) => {
            f.hidden = f.dataset.trackForm !== target;
          });
        });
      });

      const orderForm = root.querySelector('[data-track-form="order"]');
      const carrierForm = root.querySelector('[data-track-form="carrier"]');

      orderForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        const orderInput = root.querySelector('[data-track-order-input]');
        const emailInput = root.querySelector('[data-track-email-input]');
        const errorEl = root.querySelector('[data-track-error]');
        const rawOrder = (orderInput?.value || '').trim();
        const rawEmail = (emailInput?.value || '').trim();

        if (!rawOrder || !rawEmail || !rawEmail.includes('@')) {
          if (errorEl) {
            errorEl.textContent = 'Please enter both your Order Number and the Email Address used at checkout.';
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;

        const cleanOrder = rawOrder.startsWith('#') ? rawOrder : `#${rawOrder}`;
        const safeOrder = cleanOrder.replace(/[<>&"']/g, '');
        const safeEmail = rawEmail.replace(/[<>&"']/g, '');
        // Shopify exposes real order status only after the buyer verifies the checkout email, so the lookup hands off to customer accounts.
        const accountUrl = resultBox?.dataset.trackAccountUrl || '/account';
        if (badgeEl) badgeEl.textContent = 'Secure Order Lookup';
        if (titleEl) titleEl.textContent = `Order ${safeOrder}`;
        if (metaEl) metaEl.textContent = `Sign in with ${safeEmail} to see the live status and tracking link for this order.`;
        if (extLink) {
          extLink.href = accountUrl;
          extLink.target = '_self';
          extLink.removeAttribute('rel');
          extLink.textContent = 'View Live Order Status →';
          extLink.hidden = false;
        }
        if (stepsEl) stepsEl.hidden = true;

        const mailSubject = encodeURIComponent(`Order Status Inquiry — ${cleanOrder}`);
        const mailBody = encodeURIComponent(`Hi AXVANE Support,\n\nI would like to check the latest shipping status for my order:\nOrder Number: ${cleanOrder}\nCheckout Email: ${rawEmail}\n\nThank you!`);
        if (noteEl) {
          noteEl.innerHTML = `<strong>How it works:</strong> Tap <strong>View Live Order Status</strong>, enter <strong>${safeEmail}</strong>, and type the 6-digit code we email you. You will see order <strong>${safeOrder}</strong> with its current fulfillment status and carrier tracking link—no password needed.<br><br>Prefer a person? <a href="mailto:support@axvane.store?subject=${mailSubject}&body=${mailBody}">Email support@axvane.store with Order ${safeOrder} pre-filled →</a>`;
        }
        if (resultBox) {
          resultBox.hidden = false;
          resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });

      carrierForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        const carrierInput = root.querySelector('[data-track-carrier-input]');
        const errorEl = root.querySelector('[data-track-carrier-error]');
        const rawTracking = (carrierInput?.value || '').trim().replace(/\s+/g, '');

        if (!rawTracking || rawTracking.length < 6) {
          if (errorEl) {
            errorEl.textContent = 'Please enter a valid carrier tracking number (at least 6 characters).';
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;

        const trackUrl = `https://t.17track.net/en#nums=${encodeURIComponent(rawTracking)}`;
        if (badgeEl) badgeEl.textContent = 'Carrier Tracking Ready';
        if (titleEl) titleEl.textContent = `Tracking #${rawTracking}`;
        if (metaEl) metaEl.textContent = 'Multi-carrier real-time scan lookup (USPS / UPS / FedEx / DHL)';
        if (extLink) {
          extLink.href = trackUrl;
          extLink.target = '_blank';
          extLink.rel = 'noopener noreferrer';
          extLink.textContent = 'Open Live Carrier Scan ↗';
          extLink.hidden = false;
        }
        if (stepsEl) stepsEl.hidden = false;
        step2?.classList.remove('is-current');
        step2?.classList.add('is-done');
        step3?.classList.add('is-current');

        if (noteEl) {
          noteEl.innerHTML = `<strong>Live Carrier Portal:</strong> Click <a href="${trackUrl}" target="_blank" rel="noopener noreferrer">Open Live Carrier Scan for #${rawTracking.replace(/[<>&"']/g, '')} ↗</a> to view the latest USPS, UPS, FedEx, or international hub scan timestamps. Remember: if your parcel ever stalls or arrives damaged, your order is backed by our <strong>Shipping Guard Free Replacement Guarantee</strong> at <a href="mailto:support@axvane.store">support@axvane.store</a>.`;
        }
        if (resultBox) {
          resultBox.hidden = false;
          resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    };

    document.querySelectorAll('.axvane-track').forEach(initTrackSection);
    document.addEventListener('shopify:section:load', (e) => {
      const sec = e.target?.querySelector?.('.axvane-track') || (e.target?.classList?.contains('axvane-track') ? e.target : null);
      if (sec) initTrackSection(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
